(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.announcement-bar__inner[data-autoplay]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var autoplay = bar.dataset.autoplay === 'true' && !reduceMotion;
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    var interval;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = ((index % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function startAutoplay() {
      clearInterval(interval);
      if (autoplay) {
        interval = setInterval(function () {
          show(current + 1);
        }, speed);
      }
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    var prevBtn = bar.querySelector('[name="previous"]');
    var nextBtn = bar.querySelector('[name="next"]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(current - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(current + 1);
        startAutoplay();
      });
    }

    // Pause auto-rotation while the user hovers or is keyboard-focused inside the bar.
    bar.addEventListener('mouseenter', stopAutoplay);
    bar.addEventListener('mouseleave', startAutoplay);
    bar.addEventListener('focusin', stopAutoplay);
    bar.addEventListener('focusout', startAutoplay);

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-body"]) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.article-body[data-enable-toc="true"]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const content = section.querySelector('[data-article-content]');
      const tocList = section.querySelector('[data-article-toc-list]');
      const tocWrapper = section.querySelector('[data-article-toc]');
      if (!content || !tocList || !tocWrapper) return;

      const headings = content.querySelectorAll('h2, h3');
      if (!headings.length) {
        tocWrapper.style.display = 'none';
        return;
      }

      const usedIds = new Set();
      const links = [];

      headings.forEach((heading, index) => {
        if (!heading.id) {
          let baseId =
            heading.textContent
              .toLowerCase()
              .normalize('NFD')
              .replace(/[̀-ͯ]/g, '')
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '') || `heading-${index}`;
          let candidate = baseId;
          let counter = 1;
          while (usedIds.has(candidate) || document.getElementById(candidate)) {
            candidate = `${baseId}-${counter++}`;
          }
          heading.id = candidate;
          usedIds.add(candidate);
        }

        const li = document.createElement('li');
        li.className = `article-body__toc-item article-body__toc-item--${heading.tagName.toLowerCase()}`;

        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        link.className = 'article-body__toc-link';
        link.dataset.tocTarget = heading.id;

        link.addEventListener('click', (e) => {
          e.preventDefault();
          const target = document.getElementById(heading.id);
          if (!target) return;
          const offset = 100;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
          history.replaceState(null, '', `#${heading.id}`);
        });

        li.appendChild(link);
        tocList.appendChild(li);
        links.push(link);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              links.forEach((l) => l.classList.toggle('is-active', l.dataset.tocTarget === id));
            }
          });
        },
        { rootMargin: '-20% 0px -65% 0px', threshold: 0 }
      );

      headings.forEach((h) => observer.observe(h));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  /*
   * Amélioration progressive uniquement : ouvre la question ciblée par un lien
   * profond (#faq-q-xxx). La page reste entièrement fonctionnelle sans JavaScript,
   * les accordéons reposant sur <details>/<summary>.
   */
  (function () {
    function openFromHash() {
      var hash = window.location.hash;
      if (!hash) return;
      if (hash.indexOf('#faq-q-') !== 0) return;

      var target = document.getElementById(hash.slice(1));
      if (!target) return;
      if (target.tagName !== 'DETAILS') return;

      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    if (document.readyState !== 'loading') {
      openFromHash();
    } else {
      document.addEventListener('DOMContentLoaded', openFromHash);
    }

    window.addEventListener('hashchange', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initScrollIndicator(indicator) {
      if (indicator.dataset.scrollIndicatorInit === 'true') return;
      indicator.dataset.scrollIndicatorInit = 'true';

      var sliderId = indicator.dataset.sliderId;
      var slider = sliderId ? document.getElementById(sliderId) : null;
      if (!slider) return;

      var prevBtn = indicator.querySelector('[data-direction="prev"]');
      var nextBtn = indicator.querySelector('[data-direction="next"]');
      if (!prevBtn && !nextBtn) return;

      function getStep() {
        var items = slider.querySelectorAll('[id^="Slide-"]');
        if (items.length < 2) return slider.clientWidth * 0.85;
        return items[1].offsetLeft - items[0].offsetLeft;
      }

      function updateDisabledState() {
        var atStart = slider.scrollLeft <= 1;
        var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function scroll(direction) {
        var step = getStep();
        slider.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scroll(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scroll(1); });

      slider.addEventListener('scroll', updateDisabledState, { passive: true });
      window.addEventListener('resize', updateDisabledState);
      updateDisabledState();
    }

    function init() {
      document.querySelectorAll('[data-scroll-indicator]').forEach(initScrollIndicator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.hero-banner--animated';
    var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

    function reveal(el) {
      el.classList.add('is-visible');
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Sources are held in `data-src` so only the format actually displayed at
    // the current breakpoint is ever downloaded.
    function activateLayer(layer) {
      var media = layer.querySelector('.hero-banner__video, .hero-banner__iframe');
      if (!media) return;

      var wantsAutoplay = media.getAttribute('data-hero-video-autoplay') === 'true';
      var reduced = prefersReducedMotion();

      // Reduced motion: keep the poster frame instead of playing. An autoplaying
      // embed cannot be stopped from the outside, so it is simply never loaded.
      if (reduced && wantsAutoplay) {
        if (media.tagName === 'IFRAME') return;
        media.autoplay = false;
        media.removeAttribute('autoplay');
      }

      if (layer.getAttribute('data-hero-video-loaded') !== 'true') {
        if (media.tagName === 'IFRAME') {
          media.src = media.getAttribute('data-src');
        } else {
          var sources = media.querySelectorAll('source[data-src]');
          Array.prototype.forEach.call(sources, function (source) {
            source.src = source.getAttribute('data-src');
          });
          try {
            media.load();
          } catch (e) {
            /* nothing loadable yet */
          }
        }
        layer.setAttribute('data-hero-video-loaded', 'true');
      }

      if (media.tagName === 'IFRAME') return;
      if (!wantsAutoplay || reduced) return;

      var played = media.play();
      if (played && played.catch) {
        played.catch(function () {
          /* autoplay refused by the browser: the poster stays visible */
        });
      }
    }

    function deactivateLayer(layer) {
      var video = layer.querySelector('.hero-banner__video');
      if (!video) return;
      try {
        video.pause();
      } catch (e) {
        /* nothing to pause yet */
      }
    }

    function syncVideos(scope) {
      var layers = scope.querySelectorAll('[data-hero-video-layer]');
      if (!layers.length) return;

      Array.prototype.forEach.call(layers, function (layer) {
        var mode = layer.getAttribute('data-hero-video-layer');
        var isActive = mode === 'any';
        if (!isActive) {
          isActive = (mode === 'desktop') === DESKTOP_MQ.matches;
        }

        if (isActive) {
          activateLayer(layer);
        } else {
          deactivateLayer(layer);
        }
      });
    }

    function onBreakpointChange() {
      syncVideos(document);
    }

    if (DESKTOP_MQ.addEventListener) DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    else if (DESKTOP_MQ.addListener) DESKTOP_MQ.addListener(onBreakpointChange);

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;

      syncVideos(scope);

      var banners = scope.querySelectorAll(SELECTOR);
      if (!banners.length) return;

      // Gate the hidden initial state behind a JS-added class so text stays
      // visible if the script never runs.
      banners.forEach(function (el) {
        el.classList.add('hero-banner--js-ready');
      });

      var inEditor = window.Shopify && window.Shopify.designMode;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var noObserver = !('IntersectionObserver' in window);

      if (inEditor || prefersReduced || noObserver) {
        banners.forEach(reveal);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
      );

      function isAlreadyVisible(el) {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        if (visibleHeight <= 0) return false;
        var elHeight = rect.height || 1;
        return visibleHeight / Math.min(elHeight, vh) >= 0.15;
      }

      banners.forEach(function (el) {
        if (isAlreadyVisible(el)) {
          reveal(el);
        } else {
          observer.observe(el);
        }
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:select', function (event) {
      var el = event.target.querySelector(SELECTOR);
      if (el) reveal(el);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var banner = event.target.closest(SELECTOR);
      if (banner) reveal(banner);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-season-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.lookbook-gallery-section');
    if (!sections.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(initSection);

    function initSection(root) {
      const enableClipReveal = root.dataset.enableClipReveal === 'true' && !reduceMotion;
      const enableParallax = root.dataset.enableParallax === 'true' && !reduceMotion;
      const enableAnimations = root.dataset.enableAnimations === 'true';
      const enableLightbox = root.dataset.enableLightbox === 'true';

      // Arms the CSS hidden state of the clip-path reveal (no JS = photos visible).
      root.classList.add('lsg--js');

      const items = Array.from(root.querySelectorAll('.lookbook-gallery__item'));
      const sideCounter = root.querySelector('[data-side-counter]');
      const sideCurrent = root.querySelector('[data-side-counter-current]');
      const sideLine = root.querySelector('[data-side-counter-line]');

      // 1. Reveal animation + side counter sync
      if (items.length) {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (enableAnimations && enableClipReveal) {
                  entry.target.classList.add('is-visible');
                }
                revealObserver.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
        );

        items.forEach((item) => {
          if (enableAnimations && enableClipReveal) {
            revealObserver.observe(item);
          } else {
            item.classList.add('is-visible');
          }
        });

        if (sideCounter && sideCurrent && sideLine) {
          const counterObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const idx = parseInt(entry.target.dataset.photoIndex, 10);
                  if (!isNaN(idx)) {
                    sideCurrent.textContent = String(idx).padStart(2, '0');
                    const total = items.length;
                    const progress = Math.round((idx / total) * 100);
                    sideLine.style.setProperty('--side-counter-progress', progress + '%');
                  }
                }
              });
            },
            { threshold: 0.5 }
          );
          items.forEach((item) => counterObserver.observe(item));
        }
      }

      // 2. Parallax on full-width photos
      if (enableParallax) {
        const parallaxItems = Array.from(
          root.querySelectorAll(
            '.lookbook-gallery__item--position-1, .lookbook-gallery__item--position-5'
          )
        );

        if (parallaxItems.length) {
          let ticking = false;
          const update = () => {
            parallaxItems.forEach((item) => {
              const rect = item.getBoundingClientRect();
              if (rect.bottom < 0 || rect.top > window.innerHeight) return;
              const img = item.querySelector('.lookbook-gallery__image');
              if (!img) return;
              const progress =
                (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
              const translateY = (progress - 0.5) * 60;
              img.style.transform = `translateY(${translateY}px) scale(1.08)`;
            });
            ticking = false;
          };

          window.addEventListener(
            'scroll',
            () => {
              if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
              }
            },
            { passive: true }
          );
          update();
        }
      }

      // 3. Lightbox
      if (enableLightbox) {
        initLightbox(root, items);
      }
    }

    function initLightbox(root, items) {
      const lightbox = root.querySelector('[data-lightbox]');
      if (!lightbox) return;

      const triggers = Array.from(root.querySelectorAll('[data-lightbox-trigger]'));
      const imgCurrent = lightbox.querySelector('[data-lightbox-image-current]');
      const imgNext = lightbox.querySelector('[data-lightbox-image-next]');
      const counterCurrent = lightbox.querySelector('[data-lightbox-current]');
      const closeBtns = Array.from(lightbox.querySelectorAll('[data-lightbox-close]'));
      const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      const nextBtn = lightbox.querySelector('[data-lightbox-next]');
      const autoplayBtn = lightbox.querySelector('[data-lightbox-autoplay]');
      const autoplayIcon = lightbox.querySelector('[data-lightbox-autoplay-icon]');

      // srcset (900/1600/2400w) + sizes 100vw: phones no longer get the 2400px file.
      const photos = items.map((item) => ({
        src: item.dataset.photoSrc,
        srcset: item.dataset.photoSrcset || '',
        alt: item.dataset.photoAlt || ''
      }));

      const LIGHTBOX_SIZES = '100vw';
      const applyPhoto = (img, photo) => {
        if (photo.srcset) {
          img.sizes = LIGHTBOX_SIZES;
          img.srcset = photo.srcset;
        }
        img.src = photo.src;
        img.alt = photo.alt;
      };

      const total = photos.length;
      const counterTotal = lightbox.querySelector('[data-lightbox-total]');
      if (counterTotal) counterTotal.textContent = String(total);
      let currentIdx = 0;
      let lastFocused = null;
      let autoplayTimer = null;
      let autoplayActive = false;
      const autoplayDuration = parseInt(root.dataset.lightboxAutoplayDuration, 10) || 4000;
      const keyboardEnabled = root.dataset.lightboxKeyboard === 'true';

      function preload(idx) {
        if (idx < 0 || idx >= total) return;
        const img = new Image();
        applyPhoto(img, photos[idx]);
      }

      function setCurrent(idx) {
        currentIdx = ((idx % total) + total) % total;
        const photo = photos[currentIdx];

        // Crossfade: stage next, swap, then reset
        applyPhoto(imgNext, photo);
        lightbox.classList.add('is-fading');

        const onTransitionEnd = () => {
          applyPhoto(imgCurrent, photo);
          lightbox.classList.remove('is-fading');
          imgNext.removeEventListener('transitionend', onTransitionEnd);
        };
        imgNext.addEventListener('transitionend', onTransitionEnd, { once: true });

        if (counterCurrent) counterCurrent.textContent = String(currentIdx + 1).padStart(2, '0');

        preload(currentIdx + 1);
        preload(currentIdx - 1);
      }

      function open(idx) {
        lastFocused = document.activeElement;
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        currentIdx = idx;
        const photo = photos[currentIdx];
        applyPhoto(imgCurrent, photo);
        if (counterCurrent) counterCurrent.textContent = String(currentIdx + 1).padStart(2, '0');
        preload(currentIdx + 1);
        preload(currentIdx - 1);

        const focusTarget = closeBtns[closeBtns.length - 1] || lightbox;
        if (typeof trapFocus === 'function') {
          trapFocus(lightbox, focusTarget);
        } else if (focusTarget) {
          focusTarget.focus();
        }
      }

      function close() {
        stopAutoplay();
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(lastFocused);
        } else if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }

      function next() { setCurrent(currentIdx + 1); }
      function prev() { setCurrent(currentIdx - 1); }

      function startAutoplay() {
        if (autoplayActive) return;
        autoplayActive = true;
        if (autoplayIcon) autoplayIcon.textContent = '❚❚';
        autoplayTimer = setInterval(next, autoplayDuration);
      }

      function stopAutoplay() {
        autoplayActive = false;
        if (autoplayIcon) autoplayIcon.textContent = '▶';
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function toggleAutoplay() {
        if (autoplayActive) stopAutoplay();
        else startAutoplay();
      }

      // Use the trigger's contiguous position (matches the photos array) rather than
      // the raw forloop index, which has gaps when non-image entries are skipped.
      triggers.forEach((trigger, triggerIdx) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          open(triggerIdx);
        });
      });

      closeBtns.forEach((btn) => btn.addEventListener('click', close));
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
      if (autoplayBtn) autoplayBtn.addEventListener('click', toggleAutoplay);

      // Keyboard
      if (keyboardEnabled) {
        document.addEventListener('keydown', (e) => {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') { close(); }
          else if (e.key === 'ArrowLeft') { prev(); }
          else if (e.key === 'ArrowRight') { next(); }
          else if (e.key === ' ' || e.code === 'Space') {
            e.preventDefault();
            toggleAutoplay();
          }
        });
      }

      // Touch swipe
      let touchStartX = 0;
      let touchStartY = 0;
      lightbox.addEventListener(
        'touchstart',
        (e) => {
          if (!e.touches[0]) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );
      lightbox.addEventListener(
        'touchend',
        (e) => {
          if (!e.changedTouches[0]) return;
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          const absDx = Math.abs(dx);
          const absDy = Math.abs(dy);
          if (absDx > 50 && absDx > absDy) {
            if (dx < 0) next();
            else prev();
          } else if (dy > 80 && dy > absDx) {
            close();
          }
        },
        { passive: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    var SECTION_IDS = ['shopify-section-cart-footer', 'shopify-section-recently-viewed'];

    function applyEmptyState(isEmpty) {
      SECTION_IDS.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.style.display = isEmpty ? 'none' : '';
      });
    }

    function syncFromDom() {
      var cartEl = document.querySelector('cart-items');
      if (!cartEl) return;
      applyEmptyState(cartEl.classList.contains('is-empty'));
    }

    document.addEventListener('DOMContentLoaded', syncFromDom);
    syncFromDom();

    var cartEl = document.querySelector('cart-items');
    if (cartEl) {
      var observer = new MutationObserver(syncFromDom);
      observer.observe(cartEl, { attributes: true, attributeFilter: ['class'] });
    }

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') {
            applyEmptyState(event.cartData.item_count === 0);
          } else {
            syncFromDom();
          }
        });
      }
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure(wrap) {
      var desc = wrap.querySelector('.collection-banner__description');
      var btn = wrap.querySelector('.collection-banner__readmore');
      if (!desc || !btn || btn.getAttribute('aria-expanded') === 'true') return;

      desc.style.maxHeight = '';
      wrap.classList.add('is-clamped');

      if (desc.scrollHeight > desc.clientHeight + 2) {
        btn.hidden = false;
      } else {
        wrap.classList.remove('is-clamped');
        btn.hidden = true;
      }
    }

    function afterTransition(desc, callback) {
      if (reduceMotion.matches) {
        callback();
        return;
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        desc.removeEventListener('transitionend', finish);
        callback();
      }
      desc.addEventListener('transitionend', finish);
      setTimeout(finish, 500);
    }

    function toggle(wrap) {
      var desc = wrap.querySelector('.collection-banner__description');
      var btn = wrap.querySelector('.collection-banner__readmore');
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        desc.offsetHeight;
        wrap.classList.add('is-clamped');
        desc.style.maxHeight = '';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        desc.style.maxHeight = desc.clientHeight + 'px';
        wrap.classList.remove('is-clamped');
        desc.offsetHeight;
        desc.style.maxHeight = desc.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        afterTransition(desc, function () {
          if (btn.getAttribute('aria-expanded') === 'true') desc.style.maxHeight = 'none';
        });
      }
    }

    function init(root) {
      root.querySelectorAll('[data-cb-readmore]').forEach(function (wrap) {
        if (wrap.dataset.cbReady) return;
        wrap.dataset.cbReady = 'true';

        var btn = wrap.querySelector('.collection-banner__readmore');
        if (btn) {
          btn.addEventListener('click', function () {
            toggle(wrap);
          });
        }
        measure(wrap);
      });
    }

    function measureAll() {
      document.querySelectorAll('[data-cb-readmore]').forEach(measure);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureAll, 150);
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureAll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  (function () {
    const dialogs = document.querySelectorAll('[data-popup]');
    if (!dialogs.length) return;

    const inDesignMode = document.documentElement.classList.contains('shopify-design-mode');

    dialogs.forEach((dialog) => {
      const enabled = dialog.dataset.popupEnabled === 'true';
      const delay = parseInt(dialog.dataset.popupDelay, 10) || 0;
      const storageKey = dialog.dataset.popupKey;
      const subscribedKey = storageKey ? storageKey + '_subscribed' : null;
      const fingerprint = dialog.dataset.popupFingerprint || '';
      const ttlDays = parseInt(dialog.dataset.popupTtlDays, 10);
      const ttlMs = (ttlDays > 0 ? ttlDays : 90) * 86400000;
      const closeBtn = dialog.querySelector('[data-popup-close]');
      const inner = dialog.querySelector('.popup__inner');
      const newsletter = dialog.querySelector('[data-popup-newsletter]');

      // Non-modal on purpose (see stylesheet): keyboard behaviour of a modal
      // (focus on open, Escape, Tab trap, focus restore) is handled here.
      let previousFocus = null;

      const focusables = () =>
        Array.prototype.filter.call(
          inner ? inner.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])') : [],
          (el) => el.offsetParent !== null
        );

      const onKeydown = (event) => {
        if (!dialog.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          dismiss();
          return;
        }
        if (event.key !== 'Tab') return;
        const items = focusables();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (!dialog.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      const open = () => {
        if (dialog.open) return;
        previousFocus = document.activeElement;
        if (typeof dialog.show === 'function') {
          try { dialog.show(); } catch (e) {}
        } else {
          dialog.setAttribute('open', '');
        }
        document.addEventListener('keydown', onKeydown);
        if (closeBtn) {
          try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
        }
      };

      const dismiss = () => {
        try {
          if (!inDesignMode && storageKey && !hasSubscribed()) {
            sessionStorage.setItem(storageKey, fingerprint || '1');
          }
        } catch (e) {}
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        document.removeEventListener('keydown', onKeydown);
        if (previousFocus && typeof previousFocus.focus === 'function') {
          try { previousFocus.focus({ preventScroll: true }); } catch (e) {}
        }
        previousFocus = null;
      };

      // Waits for the visitor's cookie choice when the Shopify banner is shown,
      // so the popup never competes with it. Falls through immediately when the
      // Customer Privacy API is unavailable, and after 30s as a safety net.
      const whenConsentSettled = (callback) => {
        let done = false;
        const run = () => {
          if (done) return;
          done = true;
          document.removeEventListener('visitorConsentCollected', run);
          callback();
        };
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          run();
          return;
        }
        try {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            const privacy = window.Shopify.customerPrivacy;
            if (error || !privacy || typeof privacy.shouldShowBanner !== 'function' || !privacy.shouldShowBanner()) {
              run();
              return;
            }
            document.addEventListener('visitorConsentCollected', run);
            window.setTimeout(run, 30000);
          });
        } catch (e) {
          run();
        }
      };

      const hasSubscribed = () => {
        try {
          if (!subscribedKey) return false;
          const raw = localStorage.getItem(subscribedKey);
          if (!raw) return false;
          let data;
          try { data = JSON.parse(raw); } catch (e) {
            localStorage.removeItem(subscribedKey);
            return false;
          }
          if (!data || data.v !== fingerprint) {
            localStorage.removeItem(subscribedKey);
            return false;
          }
          if (typeof data.exp !== 'number' || data.exp < Date.now()) {
            localStorage.removeItem(subscribedKey);
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      };

      const markSubscribed = () => {
        try {
          if (!subscribedKey) return;
          localStorage.setItem(subscribedKey, JSON.stringify({
            v: fingerprint,
            exp: Date.now() + ttlMs,
          }));
        } catch (e) {}
      };

      const pendingKey = storageKey ? storageKey + '_pending' : null;

      const markPending = () => {
        try { if (pendingKey) sessionStorage.setItem(pendingKey, '1'); } catch (e) {}
      };

      const clearPending = () => {
        try { if (pendingKey) sessionStorage.removeItem(pendingKey); } catch (e) {}
      };

      const hasPending = () => {
        try { return !!(pendingKey && sessionStorage.getItem(pendingKey) === '1'); } catch (e) { return false; }
      };

      let serverRenderedSuccess = false;
      const wasSubscribedBeforeLoad = hasSubscribed();

      if (newsletter) {
        const form = newsletter.querySelector('.popup__form');
        const field = newsletter.querySelector('[data-popup-field]');
        const submitBtn = newsletter.querySelector('.popup__submit');
        const successText = newsletter.dataset.successMessage || '';
        const errorText = newsletter.dataset.errorMessage || '';
        const initialSuccessEl = newsletter.querySelector('.popup__message--success');

        const clearMessages = () => {
          newsletter.querySelectorAll('.popup__message').forEach((m) => m.remove());
        };

        const showMessage = (type, text) => {
          clearMessages();
          const msg = document.createElement('p');
          msg.className = 'popup__message popup__message--' + type;
          msg.setAttribute('role', type === 'error' ? 'alert' : 'status');
          msg.textContent = text;
          if (form) form.appendChild(msg);
        };

        if (form && form.getAttribute('action')) {
          try {
            const url = new URL(form.getAttribute('action'), window.location.origin);
            url.hash = '';
            form.setAttribute('action', url.pathname + url.search);
          } catch (e) {}
        }

        if (initialSuccessEl || hasPending()) {
          serverRenderedSuccess = true;
          if (field) field.style.display = 'none';
          if (!initialSuccessEl) {
            showMessage('success', successText);
          }
          markSubscribed();
          clearPending();
        }

        let submitting = false;
        if (form) {
          const submitHandler = async (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (submitting) return;
            submitting = true;

            markPending();
            if (submitBtn) submitBtn.disabled = true;
            clearMessages();

            const fallbackToNative = () => {
              form.removeEventListener('submit', submitHandler);
              if (typeof form.submit === 'function') form.submit();
            };

            try {
              const response = await fetch(form.getAttribute('action') || '/contact', {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin',
              });

              const finalUrl = response.url || '';

              if (finalUrl.indexOf('/challenge') !== -1) {
                fallbackToNative();
                return;
              }

              if (!response.ok) {
                fallbackToNative();
                return;
              }

              if (finalUrl.indexOf('customer_posted=true') !== -1) {
                if (field) field.style.display = 'none';
                showMessage('success', successText);
                markSubscribed();
                clearPending();
                submitting = false;
                if (submitBtn) submitBtn.disabled = false;
                return;
              }

              const html = await response.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const popupOk = doc.querySelector('.popup__message--success');
              const popupErr = doc.querySelector('.popup__message--error');
              const newsletterOk = doc.querySelector('.newsletter__message--success');

              if (popupOk || newsletterOk) {
                if (field) field.style.display = 'none';
                showMessage('success', successText);
                markSubscribed();
                clearPending();
                submitting = false;
                if (submitBtn) submitBtn.disabled = false;
              } else if (popupErr) {
                showMessage('error', (popupErr.textContent || '').trim() || errorText);
                clearPending();
                submitting = false;
                if (submitBtn) submitBtn.disabled = false;
              } else {
                fallbackToNative();
              }
            } catch (err) {
              fallbackToNative();
            }
          };

          form.addEventListener('submit', submitHandler);
        }
      }

      if (closeBtn) closeBtn.addEventListener('click', dismiss);

      dialog.addEventListener('click', (event) => {
        if (!inner) return;
        if (!inner.contains(event.target)) {
          dismiss();
        }
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dismiss();
      });

      if (inDesignMode) {
        open();
        return;
      }

      if (!enabled) return;

      if (wasSubscribedBeforeLoad) return;

      if (serverRenderedSuccess) {
        try {
          const url = new URL(window.location.href);
          let changed = false;
          if (url.searchParams.has('customer_posted')) {
            url.searchParams.delete('customer_posted');
            changed = true;
          }
          if (url.hash) {
            url.hash = '';
            changed = true;
          }
          if (changed) {
            history.replaceState(null, '', url.pathname + url.search);
            window.scrollTo(0, 0);
          }
        } catch (e) {}
        open();
        return;
      }

      let alreadySeen = false;
      try {
        if (storageKey) {
          const dismissedFp = sessionStorage.getItem(storageKey);
          alreadySeen = !!dismissedFp && dismissedFp === (fingerprint || '1');
          if (dismissedFp && !alreadySeen) sessionStorage.removeItem(storageKey);
        }
      } catch (e) {}

      if (alreadySeen) return;

      whenConsentSettled(() => window.setTimeout(open, delay * 1000));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mtij-slideshow')) {
    customElements.define(
      'mtij-slideshow',
      class MtijSlideshow extends HTMLElement {
        constructor() {
          super();
          this.current = 0;
          this.timer = null;
        }

        connectedCallback() {
          this.track = this.querySelector('.slideshow-section__track');
          this.slides = Array.from(this.querySelectorAll('.slideshow-section__slide'));
          if (this.slides.length === 0) return;

          this.indicators = Array.from(this.querySelectorAll('.slideshow-section__indicator'));
          this.prevBtn = this.querySelector('[name="previous"]');
          this.nextBtn = this.querySelector('[name="next"]');

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = !!(this.track && this.track.dataset.autoplay === 'true') && !this.reduceMotion;
          this.speed = (parseInt(this.track && this.track.dataset.speed, 10) || 6) * 1000;

          var initial = this.slides.findIndex(function (s) {
            return s.classList.contains('is-active');
          });
          this.current = initial > -1 ? initial : 0;
          this.show(this.current);

          var self = this;
          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', function () {
              self.step(-1);
              self.start();
            });
          }
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', function () {
              self.step(1);
              self.start();
            });
          }
          this.indicators.forEach(function (btn) {
            btn.addEventListener('click', function () {
              self.show(parseInt(btn.dataset.index, 10) || 0);
              self.start();
            });
          });

          if (this.slides.length > 1) {
            this.addEventListener('mouseenter', function () {
              self.stop();
            });
            this.addEventListener('mouseleave', function () {
              self.start();
            });
            this.addEventListener('focusin', function () {
              self.stop();
            });
            this.addEventListener('focusout', function () {
              self.start();
            });
            this.addEventListener('keydown', function (event) {
              if (event.key === 'ArrowLeft') {
                self.step(-1);
                self.start();
              } else if (event.key === 'ArrowRight') {
                self.step(1);
                self.start();
              }
            });
            this.start();
          }
        }

        disconnectedCallback() {
          this.stop();
        }

        show(index) {
          var total = this.slides.length;
          this.current = ((index % total) + total) % total;
          var cur = this.current;

          this.slides.forEach(function (slide, i) {
            var active = i === cur;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            var focusables = slide.querySelectorAll('a, button');
            focusables.forEach(function (el) {
              if (active) {
                el.removeAttribute('tabindex');
              } else {
                el.setAttribute('tabindex', '-1');
              }
            });
          });

          this.indicators.forEach(function (btn, i) {
            if (i === cur) {
              btn.setAttribute('aria-current', 'true');
            } else {
              btn.removeAttribute('aria-current');
            }
          });
        }

        step(direction) {
          this.show(this.current + direction);
        }

        start() {
          this.stop();
          if (this.autoplay && this.slides.length > 1) {
            var self = this;
            this.timer = setInterval(function () {
              self.step(1);
            }, this.speed);
          }
        }

        stop() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
